/**
 * Instance Monitor Feature Module
 *
 * Registers the instance-monitor workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the instance-monitor workspace component
registerWorkspaceComponent(
  'instance-monitor',
  lazyWorkspaceTab(() => import('./components/InstanceMonitorTab').then((m) => ({ default: m.InstanceMonitorTab }))),
);

// Re-export components
